import React, { useState, useEffect } from "react";
import * as XLSX from "xlsx";
import { useNavigate } from "react-router-dom";
import { fetchData, fetchFormData, getValueLabel } from "../../utils/options";
import topTost from "../../utils/topTost";
import Table from "../shared/table/Table";
import { IBaseUrl } from "../..";
const Lead_Header = () => {
  const userId = localStorage.getItem("id");

  const [formData, setFormData] = useState({
    excelFile: null,
    campaign: "",
    created_by: userId,
  });
  const [data, setData] = useState([]);
  const [missingMobile, setMissingMobile] = useState(0);
  const [invalidMobile, setInvalidMobile] = useState(0);
  const [sampleExists, setSampleExists] = useState(true);
  const [sampleFileUrl, setSampleFileUrl] = useState("");

  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const clearForm = () => {
    setFormData({
      excelFile: null,
      campaign: "",
      created_by: userId,
    });
    setData([]);
    setMissingMobile(0);
    setInvalidMobile(0);
    document.getElementById("fileInput").value = "";
  };

  const validateData = (incomingData) => {
    if (!Array.isArray(incomingData)) return;

    const missing = incomingData.filter(
      (row) => !row.phone_number || row.phone_number.trim() === ""
    ).length;

    const invalid = incomingData.filter(
      (row) =>
        row.phone_number &&
        (!/^[6-9]\d{9}$/.test(row.phone_number) ||
          row.phone_number.length !== 10)
    ).length;

    setMissingMobile(missing);
    setInvalidMobile(invalid);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData({ ...formData, excelFile: file });

    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });

        const formattedData = jsonData.map((row, index) => ({
          id: index + 1,
          customer_name: row.customer_name?.toString().trim() || "",
          phone_number: row["phone_number"]?.toString().trim() || "",
        }));

        const uniquePhones = new Set();
        const duplicates = [];
        const validData = [];

        formattedData.forEach((row) => {
          if (!row.phone_number) return;
          if (uniquePhones.has(row.phone_number)) {
            duplicates.push(row);
          } else {
            uniquePhones.add(row.phone_number);
            validData.push(row);
          }
        });

        if (duplicates.length > 0) {
          const ws = XLSX.utils.json_to_sheet(duplicates);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "Duplicates");
          XLSX.writeFile(wb, "Duplicate_Records.xlsx");
        }

        setData(validData);
        validateData(validData);
      };

      reader.readAsArrayBuffer(file);
    }
  };

  const handleUploadSubmit = async (e) => {
    e.preventDefault();

    try {
      const payload = data.map((item) => ({
        ...item,
        campaign: formData.campaign,
        created_by: formData.created_by,
      }));

      const result = await fetchData("bulk-inquiry", payload, "POST");
      const res = result?.result || result;

      // Download duplicates if any
      if (res.duplicate_records?.length > 0) {
        const ws = XLSX.utils.json_to_sheet(res.duplicate_records);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Duplicates");
        XLSX.writeFile(wb, "Duplicate_Records.xlsx");
      }

      if (res.inserted_count > 0 && res.TransitionID) {
        topTost({
          title: res.message || "Inquiries processed successfully.",
          icon: "success",
        });

        navigate(`/assigned-inquiry?ID=${res.TransitionID}`, {
          state: {
            insertedCount: res.inserted_count,
          },
        });
      }
    } catch (error) {
      console.error("Upload failed:", error);
      topTost({
        title: "Upload failed. Please try again.",
        icon: "error",
      });
    }
  };
  const countInvalidMobileNumbers = () => {
    return data.filter(
      (row) =>
        (row["MOBILE NUMBER"] &&
          row["MOBILE NUMBER"].toString().trim().length !== 10) ||
        isNaN(row["MOBILE NUMBER"])
    ).length;
  };

  useEffect(() => {
    const fetchSampleFile = async () => {
      try {
        const response = await fetchData("Sample-image", {}, "POST");
        const url = response?.data;
        if (url) {
          setSampleFileUrl(url);

          setSampleExists(true);
        } else {
          setSampleExists(false);
        }
      } catch (error) {
        console.error("Sample file not available:", error);
        setSampleExists(false);
      }
    };

    fetchSampleFile();
  }, []);
  const columns = [
    {
      accessorKey: "id",
      header: () => "S No",
    },
    {
      accessorKey: "customer_name",
      header: () => "Customer Name",
      defaultIsVisible: true,
    },
    {
      accessorKey: "phone_number",
      header: () => "Phone Number",
      defaultIsVisible: true,
    },
  ];

  useEffect(() => {
    validateData();
  }, [data]);

  return (
    <div className="container py-4">
      <div className="card">
        <div className="card-body">
          <h5 className="fw-bold mb-4 text-dark">Upload Leads:</h5>

          <form onSubmit={handleUploadSubmit}>
            <div className="row mb-4">
              <div className="col-md-6 d-flex align-items-center">
                <label className="col-4 fw-semibold">Upload Excel:</label>
                <input
                  type="file"
                  className="form-control col"
                  id="fileInput"
                  accept=".xlsx,.xls"
                  onChange={handleFileChange}
                  required
                />
              </div>

              <div className="col-md-6 d-flex align-items-center">
                <label className="col-4 fw-semibold">
                  Campaign:
                  <span className="text-danger py-2">*</span>
                </label>
                <input
                  type="text"
                  className="form-control col"
                  name="campaign"
                  placeholder="Enter Campaign"
                  value={formData.campaign}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="mb-4">
              <a
                style={{ cursor: "pointer" }}
                href={sampleFileUrl}
                download
                className="text-primary fw-semibold "
              >
                Click Here
              </a>
              <p className="text-muted mb-0">
                Download sample file to upload the leads.
              </p>
            </div>
            {data.length > 0 && (
              <>
                <Table data={data} columns={columns} />

                <div className="mt-4 d-flex gap-3 justify-content-center">
                  <button
                    type="button"
                    className="btn btn-secondary px-4"
                    onClick={clearForm}
                  >
                    Clear
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary px-4"
                    disabled={data.length === 0}
                  >
                    Submit
                  </button>
                </div>
              </>
            )}

            {/* Preview Section */}
            {/* <div>
              {data.length > 0 && (
                <>
                  <h5 className="fw-bold mb-3">Preview</h5>
                  <p className="text-danger">
                    {missingMobile} row(s) missing mobile number
                  </p>
                  <p className="text-danger">
                    {countInvalidMobileNumbers()} row(s) have invalid mobile
                    numbers
                  </p>

                  <div class="dataTables_length d-flex align-items-center">
                    <label class="d-flex align-items-center gap-2 m-0 m-1">
                      Show
                      <select class="form-select form-select-sm w-auto pe-4">
                        <option value="10">10</option>
                        <option value="30">30</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="200">200</option>
                        <option value="300">300</option>
                        <option value="500">500</option>
                        <option value="1000">1000</option>
                        <option value="1500">1500</option>
                        <option value="2000">2000</option>
                        <option value="2500">2500</option>
                      </select>
                      entries
                    </label>
                  </div>
                  <div>
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th>S No</th>
                            <th>Name</th>
                            <th>Phone Number</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.map((row, index) => (
                            <tr key={row.id}>
                              <td>{index + 1}</td>
                              <td>{row.customer_name}</td>
                              <td>{row.phone_number}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    <div className="mt-4 d-flex gap-3 justify-content-center">
                      <button
                        type="button"
                        className="btn btn-secondary px-4"
                        onClick={clearForm}
                      >
                        Clear
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary px-4"
                        disabled={data.length === 0}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                  <div class="row gy-2">
                    <div class="col-sm-12 col-md-5 p-0">
                      <div
                        class="dataTables_info text-lg-start text-center"
                        id="proposalList_info"
                        role="status"
                        aria-live="polite"
                      >
                        Showing 1 to 2 of 2 entries
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-7 p-0">
                      <div
                        class="dataTables_paginate paging_simple_numbers"
                        id="proposalList_paginate"
                      >
                        <ul class="pagination mb-0 justify-content-md-end justify-content-center">
                          <li class="paginate_button page-item previous disabled">
                            <a href="#" class="page-link">
                              Previous
                            </a>
                          </li>
                          <li class="paginate_button page-item active">
                            <a class="page-link" href="#">
                              1
                            </a>
                          </li>
                          <li class="paginate_button page-item next disabled">
                            <a href="#" class="page-link">
                              Next
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div> */}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Lead_Header;
